var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplearrowwhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.272009 12.4234L1.00097 13.8512C1.00097 13.975 1.16273 14.0433 1.27197 13.9676L10.7425 7.46382C10.823 7.4088 10.8881 7.33835 10.9329 7.25784C10.9777 7.17733 11.001 7.08889 11.001 6.99927C11.001 6.90964 10.9777 6.8212 10.9329 6.74069C10.8881 6.66018 10.823 6.58973 10.7425 6.53471L1.27197 0.0309676C1.16063 -0.0447646 1.00096 0.0235786 1.00096 0.147336L0.272008 1.57521C0.272008 1.66572 0.320327 1.75253 0.400159 1.80795L7.9632 6.99838L0.40016 12.1907C0.320328 12.2461 0.272009 12.3329 0.272009 12.4234Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplearrowwhite);
export default __webpack_public_path__ + "static/media/simplearrowwhite.988735c167d856f05ec6c70894d2d527.svg";
export { ForwardRef as ReactComponent };